import { forwardRef } from 'react';
import { ListBoxItemRenderProps } from 'react-aria-components';
import { IconCheck } from '@maia/icons';
import { Typography } from '../../../ui';

type Props = {
  label: string;
  className?: string;
} & ListBoxItemRenderProps;

export const DropdownOption = forwardRef<HTMLDivElement, Props>(
  ({ label, isSelected, isFocusVisible }, ref) => {
    return (
      <div
        className="flex flex-row items-center space-x-8 px-12 rounded-4 py-8 hover:bg-primary50"
        ref={ref}
      >
        <Typography
          variant="body-xs"
          weight={isSelected || isFocusVisible ? 'medium' : 'regular'}
          className="flex-1 text-grayscale600"
        >
          {label}
        </Typography>

        {isSelected && (
          <IconCheck className="min-w-16 w-16 h-16 ml-8 fill-grayscale600" />
        )}
      </div>
    );
  },
);

DropdownOption.displayName = 'DropdownOption';
